import React, {useState} from "react";
import {Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CustomTextField from "../../../../../components/customMUIComponents/CustomTextField";
import {UserProfileAddressDTO} from "../../ProfilePersonalDetails";
import useDataPut from "../../../../../hooks/useDataPut";


interface ProfileAddressesEditModalProps {
    open: boolean,
    setOpen: (open: boolean) => void,
    address: UserProfileAddressDTO
    redirectToAdressSelectionInCart?: boolean,
}

const ProfileAddressesEditModal = ({open, setOpen, address, redirectToAdressSelectionInCart = false}: ProfileAddressesEditModalProps) => {

    const [firstname, setFirstname] = useState<string>(address.firstname);
    const [lastname, setLastname] = useState<string>(address.lastname);
    const [city, setCity] = useState<string>(address.city);
    const [zip, setZip] = useState<string>(address.zip);
    const [street, setStreet] = useState<string>(address.street);
    const [streetNumber, setStreetNumber] = useState<string>(address.streetNumber);

    const {putDataPromise} = useDataPut<UserProfileAddressDTO>(`/profile-addresses/${address.id}`, {}, true, false);

    const handleSubmitEditAddress = () => {
        putDataPromise(undefined, {
            firstname,
            lastname,
            city,
            zip,
            street,
            streetNumber,
        }).then((response) => {
            if (redirectToAdressSelectionInCart && !window.location.href.includes('addresses=true')) {
                window.location.href = window.location.href+'?addresses=true';
            } else {
                window.location.reload();
            }
        })
    }

    const handleOnClose = () => {
        setOpen(false);
    }

    return (
        <Dialog
            disablePortal
            open={open}
            onClose={handleOnClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <DialogTitle>
                <Typography variant={"secondVariant"} fontSize={{xs: 18, sm: 20, md: 22}}>
                    Modifier l'adresse
                </Typography>
            </DialogTitle>
            <DialogContent sx={{
                minWidth: '300px'
            }}>
                <CustomTextField
                    value={firstname}
                    label="Prénom"
                    mb={4}
                    mt={2}
                    type="text"
                    required
                    setField={setFirstname}
                    variant="outlined"
                />

                <CustomTextField
                    value={lastname}
                    label="Nom"
                    mb={4}
                    type="text"
                    required
                    setField={setLastname}
                    variant="outlined"
                />

                <CustomTextField
                    value={city}
                    label="Ville"
                    mb={4}
                    type="text"
                    required
                    setField={setCity}
                    variant="outlined"
                />

                <CustomTextField
                    value={zip}
                    label="NPA"
                    mb={4}
                    type="text"
                    required
                    setField={setZip}
                    variant="outlined"
                />

                <CustomTextField
                    value={street}
                    label="Rue"
                    mb={4}
                    type="text"
                    required
                    setField={setStreet}
                    variant="outlined"
                />

                <CustomTextField
                    value={streetNumber}
                    label="N° de rue"
                    mb={4}
                    type="text"
                    required
                    setField={setStreetNumber}
                    variant="outlined"
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleOnClose}>Annuler</Button>
                <Button
                    onClick={handleSubmitEditAddress}
                    disabled={!firstname || !lastname || !city || !zip || !street || !streetNumber}
                >
                    Confirmer
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ProfileAddressesEditModal